import React from 'react';

function SeoTagsFooter() {
  const keywordCategories = [
    {
      title: "Fintech & Banking Services",
      tags: [
        "AEPS API Provider", "Aadhaar Enabled Payment System", "DMT Money Transfer API", "Direct Money Transfer Portal",
        "Micro ATM SDK Integration", "BBPS Bill Payment Software", "Bharat Bill Pay API", "Utility Bill Payment Gateway",
        "Aadhaar Pay Solution", "Doorstep Banking Software", "Domestic Money Remittance India", "B2B Banking Software"
      ]
    },
    {
      title: "Recharge & Utility API Solutions",
      tags: [
        "Recharge Partner", "Prepaid Mobile Recharge API", "DTH Recharge API Provider", "Multi-Operator LAPU Switcher",
        "Fastag Recharge Gateway", "Gas Bill Payment API", "Electricity Bill Payment API", "High Uptime Recharge API",
        "Instant Refund Callback API", "White Label Recharge Portal", "Distributor Retailer Software", "Commission Management Fintech"
      ]
    },
    {
      title: "Verify Verification APIs",
      tags: [
        "Bank Account Verification API", "Penny Drop Verification API", "Instant PAN Card Verification API", "Aadhaar OTP Verification API",
        "Aadhaar Offline XML Verification", "GSTIN Search & Verification API", "UPI VPA Verification API", "Vehicle RC Lookup API",
        "Driving License Verification API", "Pay Verification Suite", "Digital KYC Verification API", "Document Verification Gateway"
      ]
    },
    {
      title: "Corporate & Regional Search Tags",
      tags: [
        "Mokshiq Rakle Service Private Limited", "Mokshiq Fintech Noida", "Fintech Company Sector 2 Noida", "Top AEPS Provider Noida",
        "Retailer Panel Mokshiq", "White Label B2B Fintech India", "API Banking Solutions Uttar Pradesh", "Secure Payment Gateway India"
      ]
    }
  ];

  return (
    <section className="seo_tags_footer_section bg-dark text-light py-4 border-top border-secondary">
      <div className="container">
        <div className="seo_tags_header mb-3 pb-2 border-bottom border-secondary d-flex justify-content-between align-items-center flex-wrap">
          <h6 className="text-uppercase text-warning font-weight-bold m-0" style={{ letterSpacing: '1px', fontSize: '0.85rem' }}>
            <i className="fa-solid fa-tags me-2"></i>Mokshiq Popular Search Tags & Services
          </h6>
          <span className="text-muted small">
            Mokshiq &mdash; A Product of <strong>Rakle Service Private Limited</strong> | 1st Floor, C 78, Sector-2, Noida
          </span>
        </div>

        <div className="row">
          {keywordCategories.map((category, idx) => (
            <div key={idx} className="col-md-6 col-lg-3 mb-3">
              <h6 className="text-warning text-capitalize mb-2 font-weight-bold" style={{ fontSize: '0.88rem', borderLeft: '3px solid #f59e0b', paddingLeft: '8px' }}>
                {category.title}
              </h6>
              <div className="d-flex flex-wrap gap-1">
                {category.tags.map((tag, tagIdx) => (
                  <span 
                    key={tagIdx} 
                    className="seo_tag_pill"
                    title={`Mokshiq ${tag}`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="row pt-2 mt-2 border-top border-secondary align-items-center">
          <div className="col-md-8 text-muted small">
            <p className="mb-0 pe-lg-4" style={{ fontSize: '0.75rem', lineHeight: '1.5' }}>
              <strong>Disclaimer:</strong> Mokshiq is a technology and fintech platform operated by <strong>Rakle Service Private Limited</strong>. All brand logos, API references, and product names (such as BBPS, NSDL, NPCI, Pay, Recharge) belong to their respective registered entities and are mentioned solely for technical compatibility and service reference purposes.
            </p>
          </div>
          <div className="col-md-4 text-md-end text-muted small mt-2 mt-md-0">
            <span style={{ fontSize: '0.75rem' }}>
              <i className="fa-solid fa-shield-halved text-success me-1"></i> ISO 27001 Certified &amp; PCI-DSS Compliant Infrastructure
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SeoTagsFooter;
